"use strict";

const Err = require('@leverege/error');

class Isa {
  constructor() {
    this.tree = new Map();
  }

  static getSingleton() {
    var _GLOBAL, _GLOBAL$leveregePlugi, _GLOBAL$leveregePlugi2;

    let GLOBAL = {};

    if (typeof window === 'object') {
      GLOBAL = window;
    } else if (typeof global === 'object') {
      GLOBAL = global;
    }

    return (_GLOBAL = GLOBAL) === null || _GLOBAL === void 0 ? void 0 : (_GLOBAL$leveregePlugi = _GLOBAL.leveregePlugin) === null || _GLOBAL$leveregePlugi === void 0 ? void 0 : (_GLOBAL$leveregePlugi2 = _GLOBAL$leveregePlugi.library) === null || _GLOBAL$leveregePlugi2 === void 0 ? void 0 : _GLOBAL$leveregePlugi2.Isa;
  }
  /**
   * Define ths as a descendent of tht
   */


  add(ths, tht) {
    const val = this.tree.get(ths);

    if (this.check(tht, ths)) {
      // tht is a ths. this will be circular. reject
      throw Err.internalError('Circular Isa references are forbidden', {
        this: ths,
        that: tht
      });
    }

    if (val == null) {
      this.tree.set(ths, [tht]);
    } else if (!val.includes(tht)) {
      val.push(tht);
    }
  }

  remove(ths, tht) {
    const val = this.tree.get(ths);

    if (val != null) {
      const index = val.indexOf(tht);

      if (index >= 0) {
        val.splice(index, 1);

        if (val.length === 0) {
          this.tree.delete(ths);
        }
      }
    }
  }
  /**
   * Returns true if ths is a tht
   */


  check(ths, tht) {
    if (ths === tht) {
      return true;
    }

    const val = this.tree.get(ths);

    if (val == null || val.length === 0) {
      return false;
    } // traverse each element of val


    return val.some(prt => {
      return this.check(prt, tht);
    });
  }
  /**
   * Returns an array of all the types the ths is. If
   * includeThs is true, it will include ths as well.
   * The order of the array will be based on distance
   * await from ths.
   */


  get(ths, includeThs = true) {
    const set = new Set();
    set.add(ths);
    const iter = set.keys();
    let result = iter.next();

    while (!result.done) {
      const types = this.tree.get(result.value);

      if (types) {
        types.forEach(t => {
          set.add(t);
        });
      }

      result = iter.next();
    }

    if (includeThs === false) {
      set.delete(ths);
    }

    return Array.from(set);
  }

}

module.exports = Isa;